import { isPastDue, matchesDueDateRange } from "./paymentDueDate";
import { rctiToday } from "./rctiDates";

const cents = (value) => Math.max(0, Math.round((Number(value) || 0) * 100));
export function rctiDocumentState(row) {
  const status = String(row?.rctiStatus || "").toLowerCase();
  if (status.includes("void") || status === "invalidated") return "Voided";
  return row?.issuedAt ||
    Number(row?.emailSent) > 0 ||
    status === "paid" ||
    status === "part-paid"
    ? "Issued"
    : "Draft";
}
export function rctiOutstanding(row) {
  if (
    rctiDocumentState(row) !== "Issued" ||
    String(row?.rctiStatus).toLowerCase() === "paid"
  )
    return 0;
  return Math.max(0, cents(row.finalAmount) - cents(row.paymentAmount)) / 100;
}
export function rctiPaymentState(row, today = rctiToday()) {
  const state = rctiDocumentState(row);
  if (state !== "Issued") return "Not payable";
  if (!rctiOutstanding(row)) return "Paid";
  if (isPastDue(row.dueDate, today)) return "Overdue";
  return cents(row.paymentAmount) > 0 ? "Part-paid" : "Unpaid";
}
export function rctiRegisterSummary(rows, today = rctiToday()) {
  const result = {
    outstandingCents: 0,
    overdueCents: 0,
    draftCents: 0,
    outstandingCount: 0,
    overdueCount: 0,
    draftCount: 0,
  };
  for (const row of rows) {
    if (rctiDocumentState(row) === "Draft") {
      result.draftCents += cents(row.finalAmount);
      result.draftCount++;
    }
    const balance = cents(rctiOutstanding(row));
    if (balance) {
      result.outstandingCents += balance;
      result.outstandingCount++;
    }
    if (rctiPaymentState(row, today) === "Overdue") {
      result.overdueCents += balance;
      result.overdueCount++;
    }
  }
  return {
    outstanding: result.outstandingCents / 100,
    overdue: result.overdueCents / 100,
    drafts: result.draftCents / 100,
    outstandingCount: result.outstandingCount,
    overdueCount: result.overdueCount,
    draftCount: result.draftCount,
  };
}
export function rctiMatchesDueRange(row, range, today = rctiToday()) {
  if (range === "All dates") return true;
  if (range === "Overdue") return rctiPaymentState(row, today) === "Overdue";
  return matchesDueDateRange(row.dueDate, range, new Date(`${today}T12:00:00`));
}
export function rctiRegisterOrder(first, second) {
  const latest = (row) => Math.max(0, ...[row.lastModifiedDate, row.updatedAt, row.createdDate, row.createdAt].map((value) => Date.parse(value) || 0));
  return latest(second) - latest(first) || String(second._id || "").localeCompare(String(first._id || ""));
}

export function rctiMatchesTab(row, tab, today = rctiToday()) {
  if (tab === "All") return true;
  if (["Issued", "Draft", "Voided"].includes(tab))
    return rctiDocumentState(row) === tab;
  if (tab === "Part-paid")
    return (
      rctiDocumentState(row) === "Issued" &&
      rctiOutstanding(row) > 0 &&
      Number(row.paymentAmount) > 0
    );
  return rctiPaymentState(row, today) === tab;
}
